import { FC } from "react";

import { TagTab } from "./presentations";

export const TagTabContainer: FC<
  React.PropsWithChildren<React.PropsWithChildren<unknown>>
> = () => <TagTab />;
